import React from 'react';
import './index.css';
import {routine, treatment} from '../../setting';
import RecommendationTabs from './components/RecommendationTabs';
import DescriptionContent from './components/DescriptionContent';
import SkinReport from '../SkinReport';
import ImageRecommendations from './components/ImageRecommendations';
import ProductRecommendations from './components/ProductRecommendations';
import {getActionButtonColor} from '../../../../config/utils/commonUtils';

export default function ResultsContainer({
  skincareRecommendMode,
  recommendCategory,
  index,
  setIndex,
  activeDetection,
  detectionMapping,
  isShowSkinAge,
  detectionDescriptionContent,
  activeLang,
  isLandscape,
  commonData = {},
  buttonText,
}) {
  const actionButtonColor = getActionButtonColor(commonData);

  const renderRecommendationContent = () => {
    switch (index) {
      case 'productRecommend':
        return <ProductRecommendations isLandscape={isLandscape} />;
      case 'routineRecommend':
        return (
          <ImageRecommendations
            images={routine}
            isLandscape={isLandscape}
            landscapeWidth="14%"
            portraitWidth="21%"
          />
        );
      case 'treatmentRecommend':
        return (
          <ImageRecommendations
            images={treatment}
            isLandscape={isLandscape}
            landscapeWidth="30%"
            portraitWidth="45%"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="skincaredetectionpreview-results-container">
      {skincareRecommendMode === 'recommendation' ? (
        <div>
          <RecommendationTabs
            recommendCategory={recommendCategory}
            index={index}
            setIndex={setIndex}
          />
          {renderRecommendationContent()}
        </div>
      ) : skincareRecommendMode === 'description' ? (
        <DescriptionContent
          activeDetection={activeDetection}
          detectionMapping={detectionMapping}
          isShowSkinAge={isShowSkinAge}
          detectionDescriptionContent={detectionDescriptionContent}
          activeLang={activeLang}
        />
      ) : (
        <div className="text-center kt-margin-b-20 kt-margin-t-20">
          <SkinReport 
            actionButtonColor={actionButtonColor} 
            buttonText={buttonText}
            activeLang={activeLang}
          />
        </div>
      )}
    </div>
  );
}
